import { Component, OnInit, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDto } from '../../../../../core/api/_dtos/product.dto';
import { ProductsService } from '../../../../../shared/services/data/products.service';
import { ProductGrid } from '../../../../../shared/components/products/product-grid/product-grid';
import { CategorySelector } from '../../../../../shared/components/products/category-selector/category-selector';
import { I18nService } from '../../../../../shared/services/i18n.service';

@Component({
  selector: 'app-products-section',
  standalone: true,
  imports: [
    CommonModule,
    ProductGrid,
    CategorySelector
  ],
  templateUrl: './products-section.html',
  styleUrl: './products-section.scss'
})
export class ProductsSection implements OnInit {
  products: ProductDto[] = [];
  selectedCategoryId: string | null = null;
  isLoading = false;

  constructor(
    private productsService: ProductsService,
    protected i18nService: I18nService
  ) {
    // React to language changes
    effect(() => {
      const lang = this.i18nService.languageChanged();
      if (lang) {
        this.loadProducts();
      }
    });
  }

  ngOnInit(): void {
    this.loadProducts();
  }

  onCategorySelected(categoryId: string | null): void {
    this.selectedCategoryId = categoryId;
    this.loadProducts();
  }

  private loadProducts(): void {
    this.isLoading = true;
    this.productsService.getProductsFiltered({
      per_page: 5,
      category_id: this.selectedCategoryId || undefined
    }).subscribe({
      next: (response) => {
        this.products = response.data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  get productsPageLink(): string {
    return this.i18nService.generateUrlWithLang('/products');
  }
}
